<!--最新通知-->
<template>
  <div class="page-fixed">
    <van-tabs
      v-model="navActive"
      sticky
      :swipe-threshold="3"
      line-height="2"
      color="#FE8B01"
      @click="navClick"
    >
      <van-tab
        v-for="(item, index) in tabsData"
        :key="index"
        :title="item.value"
        :clstag="`newscenter|keycount|notice-H5|tabNav-${index}`"
      >
        <div class="line"></div>
        <van-list
          v-model="loading[index]"
          :finished="finished[index]"
          :loading-text="$t('加载中...')"
          :finished-text="finishedText[index]"
          @load="onLoad(index, item)"
          v-if="!noDataBoolArr[index]"
        >
          <div class="content">
            <notice-list :data="listDataArr[index]"></notice-list>
          </div>
        </van-list>
        <van-empty
          v-else
          class="custom-image img-list-box"
          :image="require('@/assets/img-m/no-list.png')"
          :description="$t('暂无数据')"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import getTranslation from '@/locale/getTranslation'
import noticeList from '../components/noticeList'
import { getListApi, getNoticesTabApi } from '@/api/news'
export default {
  components: { noticeList },
  data() {
    return {
      language: '',
      navActive: 0,
      tabsData: [],
      loading: [],
      finished: [],
      noDataBoolArr: [],
      finishedText: [],
      listDataArr: [],
      pageNumArr: [],
      scrollTopArr: []
    }
  },
  beforeCreate() {
    this.$toast.loading({
      duration: 0,
      message: getTranslation('加载中...'),
      forbidClick: true
    })
  },
  created() {
    this.getTabs()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    async getTabs() {
      const res = await getNoticesTabApi()
      const list = res.result.data
      this.tabsData = list
      for (let i = 0; i < list.length; i++) {
        this.listDataArr.push([])
        this.loading.push(false)
        this.finished.push(false)
        this.noDataBoolArr.push(false)
        this.scrollTopArr.push(0)
        this.pageNumArr.push(1)
        this.finishedText.push(getTranslation('已经到底了~'))
      }
      this.$toast.clear()
    },
    async onLoad(index, item) {
      let pageNum = this.pageNumArr[index]
      const res = await getListApi({
        cls: item.code == 'all' ? 'Latest Notice' : item.code,
        pageNum,
        pageSize: '10'
      })
      if (res && res.result) {
        let { infos, total, pages } = res.result
        if (total == 0) {
          //判断暂无数据
          this.$set(this.noDataBoolArr, index, true)
        } else {
          let newData = this.listDataArr[index].concat(infos)
          this.$set(this.listDataArr, index, newData)
          this.loading[index] = false
          this.pageNumArr[index] = pageNum += 1 //设置页码
          if (this.pageNumArr[index] > pages) {
            this.finished[index] = true
          }
          if (total <= 10) {
            this.$set(this.finishedText, index, '')
          } else {
            this.$set(this.finishedText, index, getTranslation('已经到底了~'))
          }
        }
      } else {
        this.$set(this.loading, index, false)
        this.$set(this.noDataBoolArr, index, true)
      }
    },
    navClick() {
      //定位到上次阅读位置
      const scrollTo = this.scrollTopArr[this.navActive]
      setTimeout(() => {
        window.scrollTo(0, scrollTo)
      }, 0)
    },
    handleScroll() {
      let scrollY = window.scrollY
      this.scrollTopArr[this.navActive] = scrollY
    }
  },
  activated() {
    try {
      let options = {
        source: '新闻中心-首页',
        isShow: false
      }
      window.bridge.onShowShareButton(JSON.stringify(options))
    } catch (error) {
      console.log('APP隐藏分享按钮监听失败')
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'mobile_detail') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/common.scss';
/deep/.van-tabs__wrap {
  border-bottom: 1px solid #e6e9ee;
  .van-tab {
    font-size: 0.28rem;
    color: #333;
    padding: 0 0.3rem;
    flex-basis: auto !important;
  }
}
/deep/.van-tab--active {
  font-weight: 400;
}
.line {
  height: 0.2rem;
  background: $mainBackground;
}
.content {
  padding: 0 0.3rem;
}
</style>
